import { render, staticRenderFns } from "./QuotesSection.vue?vue&type=template&id=63460658&scoped=true"
import script from "./QuotesSection.vue?vue&type=script&lang=js"
export * from "./QuotesSection.vue?vue&type=script&lang=js"
import style0 from "./QuotesSection.vue?vue&type=style&index=0&id=63460658&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63460658",
  null
  
)

export default component.exports